import { css } from '@emotion/css'
import styled from '@emotion/styled'

export const Wrapper = styled.div`
  text-align: left;

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 30px;
    border-radius: 4px;
    font-size: 13px;

    .ant-select-selection-search {
      left: 8px;
      right: 8px;
    }

    input.ant-select-selection-search-input {
      height: 28px;
    }

    .ant-select-selection-placeholder {
      color: #999999;
      line-height: 28px;
      opacity: 1;
    }
  }

  .ant-select {
    width: 100%;
  }
`

// Styles for dropdown list
export const WrapperList = css`
  .ant-select-item {
    &.last {
      border-top: 1px solid rgba(0, 0, 0, 0.06);

      label {
        cursor: pointer;
        color: #3b7de9;
      }
    }
  }
`
